module.exports = __webpack_public_path__ + "static/media/testBotBg.837734b2.png";